/**
 * Z-index tokens. Centralizes the layering values previously hard-coded across
 * the app (sticky table headers, copy feedback bubbles, drawers, overlays).
 */
export const zIndices = {
	hide: -1,
	base: 0,
	docked: 10,
	stickyTableHeader: 11,
	dropdown: 1000,
	sticky: 1100,
	banner: 1200,
	overlay: 1300,
	modal: 1400,
	popover: 1500,
	copyFeedback: 1600,
	toast: 1700,
	tooltip: 1800,
} as const;

export default zIndices;
